var map = {
	"./euro2024.webp": 1507,
	"./euro2024_title.svg": 1508,
	"./event-sport-bg.jpg": 1509,
	"./event-sport-bg.png": 1510,
	"./home-icon-active.webp": 1511,
	"./home-icon.webp": 1512,
	"./img_bg-uefa.png": 1513,
	"./live-icon-active.webp": 1514,
	"./master-bg.webp": 1515,
	"./me-icon-active.webp": 1516,
	"./product-overview-bg.webp": 1517,
	"./promos-icon-active.webp": 1518,
	"./sponsor-icon-active.webp": 1519,
	"./uefa-icon-active.webp": 1520,
	"./uefa-icon.webp": 1521,
	"./uefa-prediction.webp": 1522,
	"./wwr-img.webp": 1523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;